import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getUserList,
	addNewUser,
	updateUser,
	deleteUser,
	getUser,
	privacyPolicyUser,
	passwordUser,
	infoUser,
} from '../user/thunk';

export const initialState = {
	itemUserList: [],
	itemUserDetail: null,
	isUserLoading: false,
	isUserSuccess: false,

	userList: [],
	userListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false
};

const UserSlice = createSlice({
	name: 'Users',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getUser.fulfilled, (state, action) => {
			state.isUserLoading = false;
			state.isUserSuccess = true;
			state.itemUserDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getUser.pending, state => {
			state.isUserLoading = true;
			state.isUserSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getUser.rejected, (state, action) => {
			state.isUserLoading = false;
			state.isUserSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getUserList.pending, state => {
			state.isUserSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getUserList.fulfilled, (state, action) => {
			state.itemUserList = action.payload;
			state.userList = action.payload;
			state.isLoadingList = false;
			state.isUserSuccess = true;

			let userListSelect = [];
			action.payload.map(item =>
				userListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.userListSelect = userListSelect;
		});
		builder.addCase(getUserList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUserSuccess = true;
		});
		builder.addCase(addNewUser.fulfilled, (state, action) => {
			state.itemUserList.push(action.payload);
			state.userList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewUser.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewUser.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateUser.fulfilled, (state, action) => {
			state.itemUserList = state.itemUserList.map(user =>
				user.username === action.payload.old_user
					? { ...user, ...action.payload.updated_user }
					: user
			);
			state.userList = state.userList.map(user =>
				user.username === action.payload.old_user
					? { ...user, ...action.payload.updated_user }
					: user
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateUser.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateUser.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteUser.fulfilled, (state, action) => {
			state.itemUserList = current(state.itemUserList).filter(
				user => user.username !== action.payload.user
			);
			state.userList = current(state.userList).filter(
				user => user.username !== action.payload.user
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteUser.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteUser.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(privacyPolicyUser.fulfilled, (state, action) => {
			state.isUpdated = false;
		});
		builder.addCase(privacyPolicyUser.pending, (state, action) => {
			state.isUpdated = true;
		});
		builder.addCase(privacyPolicyUser.rejected, (state, action) => {
			state.isUpdated = false;
		});

		

		builder.addCase(passwordUser.fulfilled, (state, action) => {
			state.isUpdated = false;
		});
		builder.addCase(passwordUser.pending, (state, action) => {
			state.isUpdated = true;
		});
		builder.addCase(passwordUser.rejected, (state, action) => {
			state.isUpdated = false;
		});

		

		

		builder.addCase(infoUser.fulfilled, (state, action) => {
			state.isUpdated = false;
		});
		builder.addCase(infoUser.pending, (state, action) => {
			state.isUpdated = true;
		});
		builder.addCase(infoUser.rejected, (state, action) => {
			state.isUpdated = false;
		});
	},
});

export const {
	setRequireCloseModal
} = UserSlice.actions;

export default UserSlice.reducer;
